export const despace = string => (string || '').replace(/\s+/g, ' ').trim();
